<template lang="pug">
  .modal-de-confirmacao-de-ponto-sem-voz
    div O uso do microfone é necessário para a gravação de voz, uma medida de segurança no registro requisitada pelo seu empregador. Por favor volte a tela anterior e habilite a permissão de uso do microfone no seu navegador.
    label(
      v-if="exibirNaoMostrarNovamente"
      for="nao-mostrar-novamente"
    )
      input(
        type="checkbox"
        name="nao-mostrar-novamente"
        v-model="memorizador"
      )
      span Não mostrar novamente
</template>

<script>
import { memorizadorLocal } from 'src/common/mixins'

export default {
  name: 'ModalDeConfirmacaoDePontoSemVoz',

  mixins: [memorizadorLocal()],

  props: {
    exibirNaoMostrarNovamente: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
label[for="nao-mostrar-novamente"] {
    margin-top: 2rem;
    display: block;
    text-align: left;
}

label[for="nao-mostrar-novamente"] span {
    margin-left: 1rem
}
</style>